package ai.flowstorm.core.video

import kotlinx.serialization.Serializable


@Serializable
data class VideoPreviewResponse(
    val url: String
)
